/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {InspectorControls} from '@wordpress/block-editor';
/**
* Internal dependencies
*/
import {VayuBlocksHeaderTab,usePanelSettings} from '@vayu-blocks';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import HeadingSettingPanel from './settings/index.js';
import {
	Fragment,
	useState
} from '@wordpress/element';

const panelKeys = [
	'vb-heading-general',
	'vb-heading-typo',
];

const initialPanels = {
	style: 'vb-heading-general',
    advanced: '',
};

const panelOptions = [
	{ label: __( 'Style', 'vayu-blocks' ), value: 'style', icon: 'diamond'},
	{ label: __( 'Advanced', 'vayu-blocks' ), value: 'advanced', icon: 'colorpalette'}
];

const InsSettings = (props) => {
	const {
		attributes,
		setAttributes,
		clientId
	} = props;

   const {tab, setTab, openPanels, onTogglePanel  } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'style' });
   const tabComponents = {
			style: <HeadingSettingPanel attributes={attributes} setAttributes={setAttributes}  openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
			advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} exclude={['displayConditions']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
   return (
   <Fragment>
	   <InspectorControls>
		   <div className='th-block-ins'>
		   <VayuBlocksHeaderTab 
									value={ tab }
									options={panelOptions}
									onChange={ setTab }
								/>
		   
								{tabComponents[tab]}
    </div>
	</InspectorControls>
    </Fragment>
   );
};
export default InsSettings;